"use client";
import { Icon } from "@iconify/react";
import { cn } from "../../../../helper/utilityHelper";
import PremiumIcon from "./Premium-Icon";
import NewTag from "../common/NewTag";

const SubMenuHandler = ({
  item,
  toggleSubmenu,
  index,
  activeSubmenu,
  collapsed,
  hovered,
}) => {
  const { title, isPremium } = item;

  return (
    <>
      {!collapsed || hovered ? (
        <div

          onClick={() => toggleSubmenu(index)}
          className={cn(
            "flex  text-default-700 group font-medium text-sm capitalize px-[10px] py-2 rounded cursor-pointer transition-all duration-100 hover:bg-primary hover:text-primary-foreground group",
            {
              "bg-primary  text-primary-foreground": activeSubmenu === index,
            }
          )}
        >
          <div className="flex-1  gap-3 flex items-start">
            <span className="inline-flex items-center     ">
              <item.icon className="w-5 h-5" />
            </span>
            <div className="flex-1  gap-3 flex items-start">
              {title}
              {item.isNew && <NewTag className="ml-2" />}
              {isPremium && <div className="flex items-center justify-center w-6 h-6"><PremiumIcon /></div>}
            </div>

          </div>
          <div className="flex-0">
            <div
              className={cn(
                " text-base rounded-full flex justify-center items-center transition-all duration-300 group-hover:text-primary-foreground",
                {
                  "rotate-90  ": activeSubmenu === index,
                  " text-default-500  ": activeSubmenu !== index,
                }
              )}
            >
              <Icon
                icon="heroicons:chevron-right-20-solid"
                className="h-5 w-5"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="relative inline-flex cursor-pointer items-center justify-center data-[state=open]:bg-primary-100 data-[state=open]:text-primary  w-12 h-12  rounded-md">
          <item.icon className="w-6 h-6" />
          {item.isNew && (
            <div className="absolute -top-1 -right-1">
              <NewTag className="text-xs px-1 py-0.5" />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SubMenuHandler;
